import { processWeirdImage } from '../image-utils';
import { MenuType } from '../../types/global';
import { ProcessDetail } from './process-detail';

export const processDetail: (detail: string, countryRegion: string) => string = (detail, countryRegion) => {
  let target = detail;
  target = processWeirdImage(target);
  target = ProcessDetail.filterArticleTag(target);
  target = ProcessDetail.processSearchTags(target, countryRegion);
  target = ProcessDetail.processPoiAnchorTags(target, countryRegion);
  target = ProcessDetail.processHashtagTags(target, countryRegion);
  target = ProcessDetail.processSpecialTags(target);
  target = ProcessDetail.draftToDetail(target);
  target = ProcessDetail.adaptiveImageSize(target);
  target = ProcessDetail.menuDecorator(target);
  return target;
};
export const processTitleTag: (
  detail: string,
  isShow: boolean,
) => MenuType[] = (detail, isShow) => {
  const target = ProcessDetail.processTitle(detail, isShow);
  return target;
};
